<template>
  <div class="has-border-b filters white">
    <div class="filters-title">
      <v-icon color="gray-6">filter_list</v-icon>
      {{ $t('Common.filters') }}
    </div>

    <div class="filters-item filters-item--search filters-item--reset">
      <v-text-field
        v-model="filters.search"
        :placeholder="$t(`${namespace}.searchCostCenter`)"
        prepend-inner-icon="search"
        :disabled="!isSuccess"
        :loading="searchIsLoading"
        color="accent"
        height="36"
        flat
        solo
        clearable
        hide-details
        @input="handleSearch"
      />
    </div>
  </div>
</template>

<script>
import debounce from 'lodash.debounce'
import { STATUS_IS_LOADING, STATUS_SUCCESS, STATUS_FAILED } from 'utils/constants'

export default {
  name: 'Filters',
  props: {
    status: {
      type: Number,
      default: STATUS_IS_LOADING
    }
  },
  computed: {
    isLoading () {
      return this.status === STATUS_IS_LOADING
    },

    isSuccess () {
      return this.status === STATUS_SUCCESS
    },

    isFailed () {
      return this.status === STATUS_FAILED
    },

    searchIsLoading () {
      return this.isLoading && Boolean(this.filters.search)
    }
  },
  data () {
    return {
      namespace: 'Views.CostCenterPage',
      filters: {
        search: null,
        costCenterId: null
      }
    }
  },
  methods: {
    emitEvent () {
      // eslint-disable-next-line
      const { costCenter, ...rest } = this.filters
      this.$emit('change', rest)
    },

    handleSearch: debounce(function () {
      this.emitEvent()
    }, 1000),

    handleChange (val) {
      this.filters.costCenterId = val
      this.emitEvent()
    }
  }
}
</script>
